import styled from 'styled-components';
import { media } from '@minerva-analytics/pantheon';

const QuizSelectionSectionContainer = styled.div`
  padding: 0rem 2rem;
  max-width: 1050px;
  margin: 0 auto;
  padding-top: 100px;
`;

const CategoryHeader = styled.h2`
  padding: 15px 10px;
  margin-bottom: 20px;
`;

const SelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  ${media.medium`
    flex-direction: column;
    align-items: center;
  `}
`;

export {
  QuizSelectionSectionContainer,
  CategoryHeader,
  SelectionContainer,
};
